import { CustomDragDrop } from "./CustomContainer";

/**
 * Componente adaptador entre CustomDragDrop y el formulario que envía datos.
 *
 * Responsabilidad:
 * - Recibe archivos en formato Base64 (DTO de UI)
 * - Los convierte a objetos File reales
 * - Mantiene en el estado SOLO File[] (lo que entiende FormData)
 *
 * De esta forma:
 * - La UI queda desacoplada del transporte HTTP
 * - El backend siempre recibe archivos válidos
 */
export default function DragComponent({ ownerLicense, setOwnerLicense }) {

  /**
   * Recibe los archivos desde CustomDragDrop en formato serializado (Base64)
   * y los transforma a File para que puedan adjuntarse vía FormData.
   */
  function handleUpload(items) {
    const files = items.map(item =>
      base64ToFile(item.photo, item.name, item.type)
    );

    // Se guarda únicamente File[] en el estado
    setOwnerLicense(prev => [...prev, ...files]);
  }

  /**
   * Elimina un archivo del estado por índice.
   * El estado siempre representa los archivos que serán enviados.
   */
  function handleDelete(index) {
    setOwnerLicense(prev => prev.filter((_, i) => i !== index));
  }

  return (
    <div className="bg-white shadow rounded-lg w-full xl:w-[700px] px-5 pt-3 pb-5 mt-5">
      <h2 className="text-[17px] font-semibold mb-2">
        Subir Archivos
      </h2>

      {/* 
        CustomDragDrop maneja:
        - UI
        - Validaciones
        - Preview
        - Conversión File -> Base64

        Este componente solo se encarga de adaptar ese resultado
        al formato que requiere FormData.
      */}
      <CustomDragDrop
        ownerLicense={ownerLicense}
        onUpload={handleUpload}
        onDelete={handleDelete}
        count={2}
        formats={["jpg", "jpeg", "png", "pdf", "doc", "docx", "xls", "xlsx", "txt"]}
      />
    </div>
  );
}

/**
 * Convierte un archivo en Base64 a un objeto File real.
 *
 * Esto es necesario porque:
 * - Base64 sirve para UI / preview
 * - FormData y Multer requieren File / Blob / Buffer
 */
function base64ToFile(base64, filename, mimeType) {
  const byteString = atob(base64.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new File([ab], filename, { type: mimeType });
}
